import { formatBigNumber } from "@utils/formatBigNumber";

/**
 * 价格数据格式化接口
 */
export interface FormattedPriceData {
  /** 格式化后的价格字符串 */
  displayPrice?: number;
  /** 格式化后的变化百分比字符串 */
  displayChange: string | null;
  /** 格式化后的绝对变化金额字符串 */
  displayAbsoluteChange: string | null;
  /** 是否为正向变化 */
  displayIsPositive: boolean;
  title?: string;
  subtitle?: string;
  subDisplayChange?: string;
  subDisplayIsPositive?: string;
}

/**
 * 原始价格数据接口
 */
export interface RawPriceData {
  /** 原始价格 */
  rawPrice: number;
  /** 原始变化百分比 */
  rawChangePercent?: number;
  /** 原始绝对变化金额 */
  rawAbsoluteChange?: number;
}

/**
 * 格式化价格数据的配置选项
 */
export interface PriceFormatOptions {
  /** 小数位数 */
  decimals?: number;
  /** 最小零的数量 */
  minZeroCount?: number;
  /** 变化百分比精度 */
  changePercentPrecision?: number;
}

/**
 * 封装的价格数据格式化逻辑
 * 将原始的价格和变化百分比数据格式化为显示用的字符串
 */
export const formatPriceData = (
  rawData: RawPriceData,
  options: PriceFormatOptions = {},
): FormattedPriceData => {
  const {
    // decimals = 6,
    // minZeroCount = 6,
    changePercentPrecision = 2,
  } = options;

  const { rawPrice, rawChangePercent, rawAbsoluteChange } = rawData;

  // 格式化价格
  // const numStr = Number(rawPrice).toLocaleString("fullwide", {
  //   useGrouping: false,
  //   maximumFractionDigits: 20,
  // });

  // const priceData = formatNumberWithZeroCount({
  //   numStr,
  //   decimals,
  //   minZeroCount,
  // });

  // const displayPrice = priceData.isSuccess
  //   ? `$${priceData.integerPart}${priceData.leftDigits ? "." + priceData.leftDigits : ""}`
  //   : `$${rawPrice}`;

  // 格式化变化百分比
  const displayChange =
    rawChangePercent !== undefined
      ? `${rawChangePercent > 0 ? "+" : ""}${formatBigNumber(rawChangePercent, {
          needFormat: true,
          trimZeros: true,
          precision: changePercentPrecision,
        })}%`
      : null;

  // 格式化绝对变化金额
  const displayAbsoluteChange =
    rawAbsoluteChange !== undefined
      ? `${rawAbsoluteChange > 0 ? "+$" : "-$"}${Math.abs(rawAbsoluteChange).toFixed(2)}`
      : null;

  const displayIsPositive = (rawChangePercent ?? 0) > 0;

  return {
    displayPrice: rawPrice,
    displayChange,
    displayAbsoluteChange,
    displayIsPositive,
  };
};
